import { render, staticRenderFns } from "./kafa-form-success.vue?vue&type=template&id=a360ca26&lang=pug"
import script from "./kafa-form-success.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form-success.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports